import React, {Component} from 'react';
import settingsApi from "../../../apiV2/settingsApi";
import i18n from 'i18next';

export default class LayersToggle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            button: false,
        };
    }

    componentDidMount() {
        const id = this.props.id ? this.props.id + '-toggle-button' : 'layer-toggle-button';
        this.props.view.ui.add(id, {
            position: 'top-right'
        });
        if (localStorage.getItem('user_token') && this.props.useSettings != false) {
            settingsApi.getUserSetting('layer_list_state').then(result => {
                if (result.data) {
                    setTimeout(() => {
                        for (let layer of this.props.map.layers.items) {
                            for (let saved of result.data) {
                                if (saved.id === layer.id) {
                                    if(layer.id === 'gl_1' && this.props.showOpinfo){
                                        layer.visible = true
                                    }
                                    else if(layer.id === 'gl_1'){
                                        layer.visible = false
                                    }
                                    else{
                                        layer.visible = saved.visible;
                                    }
                                    if(this.props.autoLoadCustomLayersByNames && this.props.autoLoadCustomLayersByNames.includes(layer.id)){
                                        layer.visible = true;
                                    }
                                }
                            }
                        }
                    }, 4000);
                }
            });
        }
    }

    componentWillUnmount() {
        const id = this.props.id ? this.props.id + '-toggle-button' : 'layer-toggle-button';
        this.props.view.ui.remove(id);
    }

    handleChangeIcon = () => {
        this.props.toggle(!this.state.button);
        this.setState({
            button: !this.state.button
        });
    };

    render() {
        const {id} = this.props;
        let button = (this.props.buttonState && this.props.buttonState != this.state.button) ? this.props.buttonState : this.state.button;
        return (
            <div>
                <div
                    id={id ? id + '-toggle-button' : 'layer-toggle-button'}
                    onClick={this.handleChangeIcon}
                    className="esri-widget esri-widget--button esri-interactive"
                    title={i18n.t('common:header.mapLayers')}
                >
                    <span className={button ? "esri-icon-close" : "esri-icon-drag-horizontal"}/>
                </div>
            </div>
        )
    }
}
